import { render, staticRenderFns } from "./AuctionBid.vue?vue&type=template&id=8767a4b0"
import script from "./AuctionBid.vue?vue&type=script&lang=js"
export * from "./AuctionBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports